import React, { lazy } from 'react'
import Loadable from 'app/components/Loadable/Loadable'

const Home = Loadable(lazy(() => import("./home")))
const UserList = Loadable(lazy(() => import("./users/UserList")))
const UserEdit = Loadable(lazy(() => import("./users/UserEdit")))
const UserNew = Loadable(lazy(() => import("./users/UserNew")))
const UserProfile = Loadable(lazy(() => import("./users/UserProfile")))
const RequestNew = Loadable(lazy(() => import("./origination/RequestNew")))
const PreRequestNew = Loadable(lazy(() => import("./origination/PreRequestNew")))
const PreRequestEdit = Loadable(lazy(() => import("./origination/PreRequestEdit")))
const RequestList = Loadable(lazy(() => import("./origination/RequestList")))
const ConveniosList = Loadable(lazy(() => import("./Convenios/ConveniosList")))
const ConvenioNew = Loadable(lazy(() => import("./Convenios/ConvenioNew")))
const ConvenioEdit = Loadable(lazy(() => import("./Convenios/ConvenioEdit")))
const UpdateLabels = Loadable(lazy(() => import("./Creditos/UpdateLabels")))
const UploadFilePay = Loadable(lazy(() => import("./wallet/UploadFilePay")))
const PayFilesList = Loadable(lazy(() => import("./wallet/PayFilesList")))
const CreditsList = Loadable(lazy(() => import("./Creditos/CreditsList")))
const CreditsGeneralView = Loadable(lazy(() => import("./Creditos/CreditsGeneralView")))
const ApplicationPayList = Loadable(lazy(() => import("./wallet/ApplicationPayList")))
const OperativeReport = Loadable(lazy(() => import("./wallet/OperativeReport")))
const ReportList = Loadable(lazy(()=> import("./admon-wallet/reportList")))
const ReportEdit = Loadable(lazy(()=> import("./admon-wallet/reportEdit")))
const ReportNew = Loadable(lazy(()=> import("./admon-wallet/reportNew")))
const AdminFlowDate = Loadable(lazy(()=> import("./wallet/AdminFlowDate")))
const SettlementLetter = Loadable(lazy(()=> import("./Creditos/SettlementLetter")))

const customPagesRoutes = [
    {
        path: '/home',
        element: <Home />,
    },
    {
        path: '/user/user-list',
        element: <UserList />,
        auth: true
    },
    {
        path: '/user/user-edit/:id',
        element: <UserEdit />,
        auth: true
    },
    {
        path: '/user/user-new',
        element: <UserNew />,
        auth: true
    },
    {
        path: '/user/profile-list',
        element: <UserProfile />,
        auth: true
    },
    {
        path: '/origination/request-new',
        element: <RequestNew />,
        auth: true
    },
    {
        path: '/origination/pre-request-new',
        element: <PreRequestNew />,
        auth: true
    },
    {
        path: '/origination/pre-request-edit/:id',
        element: <PreRequestEdit />,
        auth: true
    },
    {
        path: '/origination/request-list',
        element: <RequestList />,
        auth: true
    },
    {
        path: '/catalog/contract-list',
        element: <ConveniosList />,
        auth: true
    },
    {
        path: '/catalog/contract-new',
        element: <ConvenioNew />,
        auth: true
    },
    {
        path: '/catalog/contract-edit/:id',
        element: <ConvenioEdit />,
        auth: true
    },
    {
        path: '/creditos/update-labels',
        element: <UpdateLabels />,
        auth: true
    },
    {
        path: '/creditos/settlement-letter',
        element: <SettlementLetter />,
        auth: true
    },
    {
        path: '/wallet/upload-file-pay',
        element: <UploadFilePay />,
        auth: true
    },
    {
        path:'/wallet/files-pay-list',
        element: <PayFilesList/>,
        auth: true
    },
    {
        path: '/wallet/credits/credits-list',
        element: <CreditsList />,
        auth: true
    },
    {
        path: '/wallet/credits/credits-view/:id',
        element: <CreditsGeneralView />,
        auth: true
    },
    {
        path: '/wallet/application-pay-list',
        element: <ApplicationPayList />,
        auth: true
    },
    {
        path: '/wallet/operative-report',
        element: <OperativeReport />,
        auth: true
    },
    {
        path: '/admon-wallet/reports-list',
        element: <ReportList />,
        auth: true
    },
    {
        path: '/admon-wallet/report-edit/:id',
        element: <ReportEdit/>,
        auth: true
    },
    {
        path: '/admon-wallet/reports-new',
        element: <ReportNew />,
        auth: true
    },
    {
        path: '/wallet/admin-flow-date',
        element: <AdminFlowDate />,
        auth: true
    }
]

export default customPagesRoutes
